'use client';

import { useServerInsertedHTML } from 'next/navigation';
import { useState } from 'react';
import { getCssText } from '@/shared/lib/stitches';

interface StitchesRegistryProps {
    children: React.ReactNode;
}

export default function StitchesRegistry({ children }: StitchesRegistryProps) {
    const [isRendered, setIsRendered] = useState(false);

    useServerInsertedHTML(() => {
        if (!isRendered) {
            setIsRendered(true);
            return <style id="stitches" dangerouslySetInnerHTML={{ __html: getCssText() }} />;
        }
    });

    return <>{children}</>;
}
